import React, { useEffect, useRef, useState } from 'react';
import SectionHeader from '../../common/section-header';
import ContactForm from './contact-form';
import "./style.css";

const ContactSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  const contactContentRef = useRef(null);

  useEffect(() => {
    const sectionNode = sectionRef.current;
    const contentNode = contactContentRef.current;

    const sectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          entry.target.classList.add('visible');
        }
      },
      { threshold: 0.1 }
    );

    const contentObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          const formSection = entry.target.querySelector('.contact-form-section');
          if (formSection) formSection.classList.add('animate');
        }
      },
      { threshold: 0.05, rootMargin: '50px 0px' }
    );

    if (sectionNode) {
      sectionObserver.observe(sectionNode);
    }

    if (contentNode) {
      contentObserver.observe(contentNode);
    }

    return () => {
      if (sectionNode) {
        sectionObserver.unobserve(sectionNode);
      }
      if (contentNode) {
        contentObserver.unobserve(contentNode);
      }
    };
  }, []);

  return (
    <section id="contact" className="contact-section" ref={sectionRef}>
      <div className="contact-container">
        <SectionHeader title="Kontakt" subTitle="Lassen Sie uns zusammenarbeiten" />

        <div className={`contact-content ${isVisible ? 'visible' : ''}`} ref={contactContentRef}>
          <div className="contact-form-section">
            <div className="form-header">
              <div className="form-header-line"></div>
              <h3 className="form-title">Nachricht senden</h3>
            </div>
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
